const PROJECTS = [
  {
    title: "Sample Project 1",
    subtitle: "Project Description",
    details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus dapibus hendrerit ligula, sit amet placerat felis finibus ac. Maecenas sodales, felis ac pretium aliquam, ipsum arcu condimentum turpis, id tempus tellus nibh ut leo.",
    tags: ["tag1", "tag2"],
    github: "https://github.com/<your-repo>",
  },
  {
    title: "Sample Project 2",
    subtitle: "Project Description",
    details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus dapibus hendrerit ligula, sit amet placerat felis finibus ac. Maecenas sodales, felis ac pretium aliquam, ipsum arcu condimentum turpis, id tempus tellus nibh ut leo.",
    tags: ["tag1", "tag2"],
    github: "https://github.com/<your-repo>",
  },
  {
    title: "Sample Project 3",
    subtitle: "Project Description",
    details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus dapibus hendrerit ligula, sit amet placerat felis finibus ac. Maecenas sodales, felis ac pretium aliquam, ipsum arcu condimentum turpis, id tempus tellus nibh ut leo.",
    tags: ["tag1", "tag2"],
    url: "https://example.com",
    github: "https://github.com/<your-repo>",
  },
];

export default PROJECTS;
